import {Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";

declare var PureKnob: any;

export function createCounterRangeValidator(maxValue, minValue) {
  return function validateCounterRange(c: FormControl) {
    const err = {
      rangeError: {
        given: c.value,
        max: maxValue,
        min: minValue
      }
    };

    return (c.value > +maxValue || c.value < +minValue) ? err : null;
  };
}

@Component({
  selector: 'app-knob',
  templateUrl: './knob.component.html',
  styleUrls: ['./knob.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => KnobComponent),
    }
  ]
})
export class KnobComponent implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {

  @Output() changed: EventEmitter<any> = new EventEmitter();

  @Input() set value(value) {
    this.knob.setProperty('val', Number(value));
  }

  @Input() set min(value) {
    this.counterRangeMin = value;
    this.knob.setProperty('valMin', this.counterRangeMin);
  }

  @Input() set max(value) {
    this.counterRangeMax = value;
    this.knob.setProperty('valMax', this.counterRangeMax);
  }

  listener;
  knob;
  validateFn;
  counterValue;
  counterRangeMax = 0;
  counterRangeMin = 0;
  propagateChange = (_: any) => {
  }

  constructor(protected el: ElementRef, private render: Renderer2) {
    const pureknob = new PureKnob();
    this.knob = pureknob.createKnob(60, 60);
    const node = this.knob.node();
    this.knob.setProperty('angleStart', -0.75 * Math.PI);
    this.knob.setProperty('angleEnd', 0.75 * Math.PI);
    this.knob.setProperty('colorFG', '#6f6f6f');
    this.knob.setProperty('trackWidth', 0.4);

    this.knob.setProperty('val', 0);
    this.listener = () => {
      this.changed.emit(this.knob.getValue());
      this.propagateChange(this.knob.getValue());
    };
    this.knob.addListener(this.listener);
    this.render.appendChild(this.el.nativeElement, node);
  }



  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

  writeValue(value: any) {
    this.counterValue = value;
  }

  get knobValue() {
    return this.knob.getValue();
  }

  set knobValue(value) {
    this.knob.setProperty('val', value);
    this.propagateChange(value);
  }

  ngOnChanges(changes) {
    if (changes.counterRangeMin || changes.counterRangeMax) {
      this.validateFn = createCounterRangeValidator(this.counterRangeMax, this.counterRangeMin);
    }
  }

  validate(c: FormControl) {
    return this.validateFn(c);
  }

  ngOnInit() {
    this.validateFn = createCounterRangeValidator(this.counterRangeMax, this.counterRangeMin);
  }

  ngOnDestroy(): void {
    // this.knob.removeEventListener(this.listener);
    this.knob.destroy();
    this.knob = null;
  }
}
